// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"admin-fee-drawer_paragraph__AuTnc"};